export default {
  id: null,
  nome: null,
  forma: null,
  exibirEmDiversos: null,
  exibirEmViagemAdm: null,
  exibirEmReembolsoGeral: null,
  categoria: null,
  descricao: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/expensetyemodel.js